// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDatadevIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDatadevIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDatadevIconOutlined = function DrrpDatadevIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDatadevIconOutlinedSvg
  }));
};

DrrpDatadevIconOutlined.displayName = 'DrrpDatadevIconOutlined';
export default React.forwardRef(DrrpDatadevIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDatadevIconOutlined.js
// module id = 2537
// module chunks = 0